import React from "react"
export function CrossFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm2.47 4.47L10 8.939l-2.47-2.47L6.47 7.53 8.939 10l-2.47 2.47 1.061 1.06L10 11.062l2.47 2.47 1.06-1.06L11.06 10l2.47-2.47-1.06-1.06z"
        fill="currentColor"
        id="prefix__cross---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
